import {
  convertBasenameToLanguage,
  getValidBasename,
  type Language,
  storageGet,
} from '@faceup/utils'
import { StorageKeys } from '../utils/useStorage'

/**
 * Best-effort language for the very first paint and the error boundary, before
 * any report-source data is loaded. Priority: URL language segment, then the
 * stored preference, then the browser language. The route wrapper later narrows
 * this to a language the report source actually offers.
 */
export const getInitialLanguage = (): Language => {
  const basename = getValidBasename()
  if (basename !== '/') {
    return convertBasenameToLanguage(basename)
  }

  const saved =
    storageGet('localStorage', StorageKeys.Language) ??
    storageGet('sessionStorage', StorageKeys.Language)

  return convertBasenameToLanguage(saved ?? navigator.language)
}
